import { createContext, useContext, useMemo, type ReactNode } from 'react';

import type { NovaHostContextPatch } from './protocol';

export interface NovaChatHostContextValue {
  setAccountUuid(uuid: string | undefined): void;
}

export interface NovaChatContextBackend {
  setContextPatch(patch: NovaHostContextPatch): void;
}

const NovaChatHostContext = createContext<NovaChatHostContextValue | undefined>(undefined);

export function NovaChatHostContextProvider({
  children,
  backend,
}: {
  children: ReactNode;
  backend: NovaChatContextBackend;
}) {
  const value = useMemo<NovaChatHostContextValue>(
    () => ({
      setAccountUuid: (uuid) => backend.setContextPatch({ accountUuid: uuid ?? null }),
    }),
    [backend],
  );

  return <NovaChatHostContext.Provider value={value}>{children}</NovaChatHostContext.Provider>;
}

export function useNovaChatContext(): NovaChatHostContextValue {
  const context = useContext(NovaChatHostContext);
  if (!context) throw new Error('useNovaChatContext must be used within NovaChatHostContextProvider');
  return context;
}

export function useNovaChatContextSafe(): NovaChatHostContextValue | undefined {
  return useContext(NovaChatHostContext);
}
